import { createAction } from "redux-actions"

/* action type */
export const SET_LOADING = "@elefarm-app/config/SET_LOADING"
export const SET_SERVER_ERROR_POPUP = "@elefarm-app/config/SET_SERVER_ERROR_POPUP"

/* action function */
export const setLoading = createAction(SET_LOADING)
export const setServerErrorPopup = createAction(SET_SERVER_ERROR_POPUP)
